import { Component, OnInit } from '@angular/core';
import { APIService } from './../api.service';
import { CommonService } from '../services/common.service';
import { Router } from '@angular/router';
import * as xlsx from 'xlsx';
import { Observable, Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-profitand-loss',
  templateUrl: './profitand-loss.component.html',
  styleUrls: ['./profitand-loss.component.scss']
})
export class ProfitandLossComponent implements OnInit {
  jarvisData: any = [];
  accountDate: any = [];
  selectedFY: any;
  financialYears: any = [];
  LedgerRecord: any = [];
  HeadRecord: any = [];
  AccurateProfitOrLoss: any = [];
  profitAndLossParameters: any = [];
  ProfitOrLoss: number = 0;
  GrandIncome: number = 0;
  GrandExpense: number = 0;
  IncomeArray: any = [];
  ExpenseArray: any = [];
  BindRecordLeft: any = [];
  BindRecordRight: any = [];
  profitLoss: any = [];
  hideZeroLevelLdgr: boolean = false;
  fromDate: any;
  toDate: any;
  selectedDate: any;
  acctStartDT: Date = new Date();
  isShowExpense: boolean = true;
  isShowIncome: boolean = false;
  agencyData: any = [];
  ERP_Agn: any = [];

  Date1 = new Date();
  Year: any = ""
  IsPrevios = 0;
  accountStartDT: any;
  year: any;
  month: any;
  fromMinDate: any;

  id : any;
  h : any;
  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();

  isWeb: boolean = true;
  show: any = {
    edit: true,
    save: false,
  };
  disable: any = {
    fromInput: true,
    toInput: true
  };
  isMobileView: boolean = this.deviceService.isMobile();
  
  constructor(private apiService: APIService, private commonService: CommonService, private router: Router, private SpinnerService: NgxSpinnerService, private deviceService: DeviceDetectorService) {

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
  }

  ngOnInit(): void {
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    };

    this.isWeb = this.apiService.apiCheckWeb();
    
    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }

    //Get Account Start DT
    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }

    this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    //this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;


    // if (this.Date1.getMonth() < 3) {
    //   this.Year = this.Date1.getFullYear() - 1
    //   this.IsPrevios = 1;
    // } else {
    //   this.Year = this.Date1.getFullYear() + 1
    //   this.IsPrevios = 0;
    // }

    // if ($('#hdnAccountStartDT').val() != "") {
    //   this.accountStartDT = new Date(this.acctStartDT).customFormat("#DD#-#MMM#-#YYYY#");
    //   this.fromMinDate = new Date(this.acctStartDT).customFormat("#DD#-#MMM#-#YYYY#");
    // }
    // else {
    //   var year1 = new Date().getFullYear();
    //   this.accountStartDT = new Date(year1 + "/04/01").customFormat("#DD#-#MMM#-#YYYY#");
    //   this.fromMinDate = new Date(year1 + "/04/01").customFormat("#DD#-#MMM#-#YYYY#");
    // }

    // this.year = new Date(this.fromMinDate).getFullYear();
    // this.month = new Date(this.fromMinDate).getMonth();

    // if (this.month < 3) {
    //   this.year = this.year - 1;
    // }
    // this.fromMinDate = new Date(this.year + "/04/01").customFormat("#DD#-#MMM#-#YYYY#");


    // // let currentDate = new Date();
    // // this.fn_Set_FinancialYear(currentDate);

    // this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    // let accountsDate: any = this.apiService.getCookie("AccountsDates");
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.selectedFY = accountsDate[0].selectedFy;
    //     this.fromDate = new Date(accountsDate[0].fdt);
    //     this.toDate = new Date(accountsDate[0].tdt);
    //   }
    //   else {
    //     this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //   }
    // }
    // else {
    //   this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;      
    //   this.fn_Set_FinancialYear(new Date());
    // }
    this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;      
    this.fn_Set_FinancialYear(new Date());

    //  / this.fn_Set_FinancialYear(this.toDate);

    this.getProfitAndLoss();

  }

  ddlchangeYear() {
    if (this.selectedFY != 'Other') {
      let selectedYear;
      selectedYear = this.selectedFY.split("-");
      let toDate = (Number(selectedYear[0]) + 1) + "/03/31";
      this.fn_Set_FinancialYear(toDate);
    }
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }

    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.AccurateProfitOrLoss = [];
    this.profitAndLossParameters = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];

    // let accountDate: Array<any> = [{
    //   fdt: this.fromDate.customFormat("#DD#-#MMM#-#YY#"),
    //   tdt: this.toDate.customFormat("#DD#-#MMM#-#YY#"),
    //   selectedFy: this.selectedFY
    // }];
    // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));


    this.getProfitAndLoss();
  }

  getProfitAndLoss() {
    let data = [{
      fromDT: this.fromDate.customFormat("#DD#-#MMM#-#YY#"),
      toDT: this.toDate.customFormat("#DD#-#MMM#-#YY#")
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 1,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        this.LedgerRecord = reponseData.Table1;
        this.HeadRecord = reponseData.Table2;
        this.AccurateProfitOrLoss = reponseData.Table3;
        //this.profitAndLossParameters = reponseData.Table4;
        this.fn_BindBalanceSheetData();
      }
    }
  }

  //fn_BindBalanceSheetData() - Bind Data to balance sheet
  fn_BindBalanceSheetData() {
    this.ProfitOrLoss = 0;
    this.GrandIncome = 0;
    this.GrandExpense = 0;
    this.IncomeArray = [];
    this.ExpenseArray = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];
    let headID: number = 0;
    //this.resetBalanceSheet();

    //Left side data bind
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 4) {
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordLeft.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          OpBal: this.HeadRecord[i].OpBal,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 4 }),
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID })
        });
      };
    }

    //Right side data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 3) {
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordRight.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          OpBal: this.HeadRecord[i].OpBal,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 3 }),
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID })
        });
      };
    }
    this.GrandIncome = this.fn_calculateGrandTotal(this.BindRecordRight, this.AccurateProfitOrLoss);
    this.GrandExpense = this.fn_calculateExpenseTotal(this.BindRecordLeft, this.AccurateProfitOrLoss);
    this.ProfitOrLoss = Number(this.GrandIncome) - Number(this.GrandExpense);
    
    // this.ProfitOrLoss = this.fn_calculateProfitLoss(this.BindRecordRight, this.BindRecordLeft, this.AccurateProfitOrLoss);
    
    if (Number(this.ProfitOrLoss) > 0) {
      // this.GrandExpense = Number(String(this.GrandExpense).replace(/\-/g, ""));
      this.GrandExpense += Number(String(this.ProfitOrLoss).replace(/\-/g, ""));
    }
    else {
      // this.GrandIncome = Number(String(this.GrandIncome).replace(/\-/g, ""));
      this.GrandIncome += Number(String(this.ProfitOrLoss).replace(/\-/g, ""));
    }

    let isHideZero = this.apiService.getCookie("hideZero");
    if(isHideZero) {
      this.hideZeroLevelLdgr = isHideZero == "true" ? true : false;
    }

  }

  fn_calculateGrandTotal(arr1: any, arr2: any) {
    var total = 0;
    if (!arr1) {
      arr1 = [];
    }

    if (!arr2) {
      arr2 = [];
    }

    for (var i = 0; i < arr1.length; i++) {
      // total += parseFloat(String(arr1[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
      total += parseFloat(String(arr1[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
    }
    for (var i = 0; i < arr2.length; i++) {
      total += parseFloat(String(arr2[i].ClosingStock).replace(/\,/g, "").replace(/\-/g, ""));
    }
    return total;
  }

  fn_calculateExpenseTotal(arr1: any, arr2: any) {
    var total = 0;
    if (!arr1) {
      arr1 = [];
    }

    if (!arr2) {
      arr2 = [];
    }

    for (var i = 0; i < arr1.length; i++) {
      // total += parseFloat(String(arr1[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
      total += parseFloat(String(arr1[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
    }
    for (var i = 0; i < arr2.length; i++) {
      total += parseFloat(String(arr2[i].OpeningStock).replace(/\,/g, "").replace(/\-/g, ""));
    }
    return total;

  }

  //fn_calculateProfitLoss() - Calculate Profit & Loss
  fn_calculateProfitLoss(incomeArray: Array<any>, expeneArray: Array<any>, stockArray: Array<any>){
      let incomeTotal: number = 0;
      for (var i = 0; i < incomeArray.length; i++) {
        let amt = String(incomeArray[i].CloBal).replace(/\,/g, "");
        if(String(amt).indexOf("-") > -1){
          incomeTotal += parseFloat(String(amt).replace(/\-/g, ""));
        }
        else{
          incomeTotal += parseFloat((Number(0) - Number(amt)).toString());
        }
      }

      let expenseTotal: number = 0;
      for (var i = 0; i < expeneArray.length; i++) {
        let amt = String(expeneArray[i].CloBal).replace(/\,/g, "");
        expenseTotal += parseFloat(String(amt));
      }

      let closinStk: number = stockArray[0].ClosingStock; 
      let opngStk: number = stockArray[0].OpeningStock; 

      return Number((incomeTotal - expenseTotal)) + Number((closinStk - opngStk));
  }

  resetBalanceSheet() {
    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.BindRecordLeft = [];
    this.GrandIncome = 0;
    this.GrandExpense = 0;
    this.profitLoss = 0;
  }

  fn_ChangeDate() {
    if (this.fromDate._d) {
      this.fromDate = this.fromDate._d;
    }

    if (this.toDate._d) {
      this.toDate = this.toDate._d;
    }

    // Here Set Accounting Year of Selected Date
    if (new Date(this.fromDate) > new Date(this.fromMinDate) && new Date(this.fromDate) < new Date(this.acctStartDT)) {
      alert("Please select date either " + this.fromMinDate + " or date after " + this.acctStartDT + ".");
      if (this.IsPrevios == 1) {
        this.fromDate = new Date(this.Year + "/04/01");
        this.toDate = new Date(this.Date1.getFullYear() + "/03/31");
      }
      else if (this.IsPrevios == 0) {
        this.fromDate = new Date(this.Date1.getFullYear() + "/04/01");
        this.toDate = new Date(this.Year + "/03/31");
      }
      return;
    }

    //fn_HeadSummary();


    //fn_Set_FinancialYear($scope.ToDate);
    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.AccurateProfitOrLoss = [];
    this.profitAndLossParameters = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];

    // let accountDate: Array<any> = [{
    //   fdt: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
    //   tdt: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#"),
    //   selectedFy: this.selectedFY
    // }];
    // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));

    this.getProfitAndLoss();
  }

  PrintProfitLoss() {
    var FDT = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#");
    var TDT = new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#");
    window.open('PrintProfitLoss?FDT=' + FDT + '&TDT=' + TDT, '_blank', 'Height= 900px, Width= 1000px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  Refresh() {

    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.AccurateProfitOrLoss = [];
    this.profitAndLossParameters = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];

    this.getProfitAndLoss();
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }

  fn_changeFinancialYear($event: any) {
    if (this.selectedFY != 'Other') {
      // let selectedYear = String(this.selectedFY).split("-");
      // let accountDate: Array<any> = [{
      //   fdt: '1-Apr-' + selectedYear[0],
      //   tdt: '31-Mar-' + selectedYear[1],
      //   selectedFy: this.selectedFY
      // }];
      // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));

      this.changingValue.next($event);
      this.changingHeadValue.next($event);
    }
    else {
      this.getProfitAndLoss();
    }
  }

  goToAccounts(headID: any, h: any, fromDT: any, toDT: any) {
    // window.location.href = "accounts";
    let url = 'accounts;id=' + headID + ';h=' + h + ";fdt=" + new Date(fromDT).customFormat("#DD#-#MMM#-#YY#") + ";tdt=" + new Date(toDT).customFormat("#DD#-#MMM#-#YY#");
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }

    window.open(url, target)
  }

   //clickHideZero() -> hide zero the set cookie
   clickHideZero(){
      this.apiService.setCookie("hideZero", this.hideZeroLevelLdgr);
  }

  editPeriod() {
    this.show.edit = false;
    this.show.save = true;
    this.disable.fromInput = false;
    this.disable.toInput = false;
  }

  changePeriod() {
    this.fn_ChangeDate();
    this.show.edit = true;
    this.show.save = false;
    this.disable.fromInput = true;
    this.disable.toInput = true;
  }

  expandView(head: any, isHead: any) {
    if(this.isMobileView){
      this.goToAccounts(head.HeadID, 1, this.fromDate, this.toDate);
      return;
    }

    let target: string = "_blank";
    let isLive = this.apiService.fn_isLiveURL();
    let fromDT = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#");
    let toDT = new Date(this.toDate).customFormat("#DD#-#MMM#-#YYYY#");
    if(this.isWeb == false){
      target = "_self";
    }

    if(isHead == '1') {
      let headID = head.HeadID;
      window.open((isLive ? '/ERP' : '') + '/HeadRecord?hid=' + encodeURIComponent(headID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    } else {
      let ledgerID = head.LedgerID;
      window.open((isLive ? '/ERP' : '') + '/LedgerRecord?lid=' + encodeURIComponent(ledgerID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    }
  }

  //   fn_ChangeDate() {
  //     // Here Set Accounting Year of Selected Date
  //     var Date1 = new Date(this.selectedDate);
  //     var acctStartDT = new Date(2015);
  //     let CurrentDate = new Date();

  //     if (Date1 < acctStartDT) {
  //         alert("Please select date after " + 2015);
  //         this.fn_Set_FinancialYear(CurrentDate);
  //         return;
  //     }

  //     var Year;
  //     var IsPrevios = 0;
  //     if (Date1.getMonth() < 3) {
  //         Year = Date1.getFullYear() - 1
  //         IsPrevios = 1;
  //     } else {
  //         Year = Date1.getFullYear() + 1
  //         IsPrevios = 0;
  //     }
  //     if (IsPrevios == 1) {
  //         this.fromDate = new Date(Year + "/04/01");
  //         //$scope.ToDate = new Date(Date1.getFullYear() + "/03/31");
  //     }
  //     else if (IsPrevios == 0) {
  //         this.fromDate = new Date(Date1.getFullYear() + "/04/01");
  //         // $scope.ToDate = new Date(Year + "/03/31");
  //     }


  //     //fn_Set_FinancialYear($scope.ToDate);
  //     this.LedgerRecord = [];
  //     this.HeadRecord = [];
  //     this.AccurateProfitOrLoss = [];
  //     this.profitAndLossParameters = [];
  //     this.BindRecordLeft = [];
  //     this.BindRecordRight = [];

  //     this.getProfitAndLoss();

  // }
}

declare global {
  interface String {
    replaceAll(search: any, replacement: any): string;
  }
}

// String Prototye
String.prototype.replaceAll = function (search: any, replacement: any) {
  var target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
}

declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}

// String Prototye
Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}
